import { getIsAQuoteTemplate } from 'Cube/domain/postActionStages/utils/getIsQuoteATemplate'
import {
  CubeReducerState,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

/**
 * NOTE @ihutc: left in the `prevState` param even though it isn't used, to allow the tests to be explicit
 * that the duplicate feature should be available on all statuses, and so there's a starting point if we ever
 * decide to change when this feature is available in the future.
 */

export const getDuplicateQuoteAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  if (getIsAQuoteTemplate(prevState)) {
    return {
      available: {
        visible: false,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.InvalidStatus,
          metadata: { status: prevState.data.common.status }
        }
      ]
    }
  }

  /**
   * An amendment is defined against one schedule's state at one moment, so a copy of it would
   * describe changes to a schedule that has since moved on. Left visible but disabled, so the
   * reason can be given rather than the action quietly going missing.
   */
  if (prevState.data.quote.dealType === 'AMENDMENT') {
    return {
      available: {
        visible: true,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.CantChangeOnAmendmentDealType,
          metadata: {}
        }
      ]
    }
  }

  return {
    available: {
      visible: true,
      enabled: true
    },
    reasons: []
  }
}
